import React, { FC } from 'react';
import { useThemes } from '@hooks/useThemes';
import styles from './RadioButton.module.css';
import { Typography, TypographyTagVariants } from '../Typography';

export enum RadioButtonType {
    normal = 'normal',
    greenVariant = 'greenVariant',
    boxed = 'boxed',
}

export interface RadioButtonProps {
    id: string;
    classes?: string;
    type: RadioButtonType;
    size?: 'sm';
    name: string;
    value: string;
    label?: string;
    disabled?: boolean;
    required?: boolean;
    checked?: boolean;
    onChange?: (value: string) => void;
    onClick?: () => void;
}

export const RadioButton: FC<RadioButtonProps> = ({
    id,
    classes,
    type,
    size,
    name,
    value,
    label,
    disabled,
    required,
    checked,
    onChange,
    onClick,
}) => {
    const { useGrayscaleTheme } = useThemes();

    return (
        <div
            className={
                `form-check ${styles['form-check']} ${useGrayscaleTheme ? styles['theme-grayscale'] : ''}` +
                ` ${type === 'boxed' ? styles['boxed-variant-container'] : ''}`
            }>
            <input
                id={id}
                className={
                    `form-check-input ${styles['form-check-input']}` +
                    ` ${size === 'sm' ? styles['form-check-input-sm'] : ''}` +
                    ` ${type === 'greenVariant' ? styles['green-check-variant'] : ''}` +
                    ` ${type === 'boxed' ? styles['boxed-variant'] : ''}` +
                    ` ${classes || ''}`
                }
                type="radio"
                name={name}
                value={value}
                disabled={disabled}
                required={required}
                checked={checked}
                onChange={(value) => onChange && onChange(value.target.value)}
                onClick={() => onClick && onClick()}
            />
            {label !== undefined && (
                <Typography classes="lh-1 align-self-center ms-2" tagVariant={TypographyTagVariants.span}>
                    <label className="form-check-label">{label}</label>
                </Typography>
            )}
        </div>
    );
};
